import {
    APP_RECEIVE_COMPONENT_FILTERS,
    APP_REMOVE_EMBROIDERY_CUSTOM_DATA,
    APP_SET_ACTIVE_COMPONENT_FILTER,
    APP_SET_CUSTOM_DATA
} from "./action-types";
import Api from "@configuratorware/configurator-frontendgui/Framework/Api";
import * as apiActions from '@configuratorware/configurator-frontendgui/App/Reducers/Actions';
import * as configuratorActions from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { SetCustomDataArgs } from "../../Types";
import { get } from "lodash";

export const setCustomData = (
  args: SetCustomDataArgs
) => ({
  type: APP_SET_CUSTOM_DATA,
  payload: args,
});

export const removeEmbroideryCustomData = () => ({
    type: APP_REMOVE_EMBROIDERY_CUSTOM_DATA
});

const _getHexValue = (color) =>
  color.attributes.find((attr) => attr.identifier === "hex_value").values[0]
    .value;

export const updateCustomColor = (color) => (dispatch) =>
  dispatch(
    setCustomData({
      textColor: { identifier: color.identifier, value: _getHexValue(color), title: color.title },
    })
  );

export const getGroupList = (groupId: string) => (dispatch) => {
  dispatch({
    type: "@GROUP/GetList:START",
  });
  Api.request(`/itempool/${groupId}`)
    .then(({ data }) =>
      dispatch({ type: "@GROUP/GetList:FULFILLED", payload: data })
    )
    .catch((err) => dispatch({ type: "@GROUP/GetList:REJECTED", error: err }));
};

export const getComponentFilters = (itemIdentifier, componentIdentifier) => (dispatch) => {

    const data = {itemIdentifier};
    return Api.request({url: `/optionclassification/${componentIdentifier}/filters`, method: 'post', data})
      .then(({ data }) =>
        dispatch({ type: APP_RECEIVE_COMPONENT_FILTERS, payload: {filters: data, filteredComponentIdentifier: componentIdentifier }})
      )
      .catch((err) => console.error(err));
}

export const setOptionFilter = (componentIdentifier, optionFilterIdentifier) => (dispatch, getState) => {
    const configuration = get(getState(), 'configurator.configuration');
    const itemIdentifier = get(getState(), 'configurator.configuration.item.identifier');
    dispatch({ type: APP_SET_ACTIVE_COMPONENT_FILTER, payload: optionFilterIdentifier });
    return dispatch(fetchOptions(itemIdentifier, componentIdentifier, configuration, optionFilterIdentifier))
}

export const fetchOptions = (itemidentifier, optionclassification, configuration, optionFilterIdentifier) => {
    const url = `options/list/${itemidentifier}/${optionclassification}?filters[filter]=${optionFilterIdentifier}`;
    return apiActions.postData(
        url,
        { configuration },
        configuratorActions.receiveOptions,
        {}, // config
        { optionclassification } // extraData
    );
};
